// Auto-generated by scripts/xliff-to-json.cjs -- do not edit by hand

export const translations: Record<string, string> = {
  's17f33773d05f3aed': `Gestion des utilisateurs`,
  'sb46734737dd208bb': `Journaux d'audit`,
  's36e195872312e3b4': `Administration du site`,
  's17669567f329206c': `Créer un site`,
  's49730f3d5751a433': `Chargement...`,
  's3741f519c32ac391': `Nouveau`,
  's417b90913e05bc17': `Aperçu`,
  'sffe2914d4b7c91ee': `Accès anticipé`,
  's3d64ea063be4c9f2': `Audit unifié`,
  's596a144afb429d94': `Plus de produits`,
  's6d8c02aee480af7a': `Menu`,
  's6abb1cd87fe0114e': `Accueil`,
  's5e8250fb85d64c23': `Fermer`,
  's691d6163aaabb69b': `Profil utilisateur`,
  's352719d86112de9a': `Aide`,
  'admin': `Administration`,
  'h88d78370fa007ca9': `Fournisseurs d'identité et d'authentification`,
  'sitemenu.dashboard': `Dashboard`,
  'sitemenu.dashboard.dynamicdashboard': `Dashboard (Aperçu)`,
  'sitemenu.assets': `Actifs`,
  'sitemenu.smartrules': `Règles intelligentes`,
  'sitemenu.discovery': `Découverte`,
  'sitemenu.discovery.newdiscoveryscan': `Exécuter une nouvelle analyse de découverte`,
  'sitemenu.discovery.activeandcompletedscans': `Analyses actives/terminées`,
  'sitemenu.discovery.scheduledscans': `Analyses planifiées`,
  'sitemenu.discovery.discoveryscanners': `Scanners de découverte`,
  'sitemenu.managedsystems': `Systèmes gérés`,
  'sitemenu.managedaccounts': `Comptes gérés`,
  'sitemenu.passwordsafe': `Password Safe`,
  'sitemenu.passwordsafe.accounts': `Comptes`,
  'sitemenu.passwordsafe.approvals': `Approbations`,
  'sitemenu.passwordsafe.activesessions': `Sessions actives`,
  'sitemenu.passwordsafe.completedsessions': `Sessions terminées`,
  'sitemenu.passwordsafe.administratorsessions': `Sessions d'administration`,
  'sitemenu.analyticsandreportingtrident': `Analyses et rapports`,
  'sitemenu.analyticsandreporting.viewallreports': `Voir tous les rapports`,
  'sitemenu.teampasswords': `Secrets Safe`,
  'sitemenu.analytics': `Analyses et rapports`,
  'sitemenu.configuration': `Configuration`,
  'sitemenu.about': `À propos`,
  'insights.menu.dashboard': `Dashboard`,
  'insights.menu.identitiesPrivileges': `Identités et privilèges`,
  'insights.menu.identities': `Identités`,
  'insights.menu.accounts': `Comptes`,
  'insights.menu.entitlements': `Droits d'accès`,
  'insights.menu.secretsSecurity': `Sécurité des secrets`,
  'insights.menu.secrets': `Secrets`,
  'insights.menu.secretsInventory': `Inventaire des secrets`,
  'insights.menu.aiSecurity': `Sécurité IA`,
  'insights.menu.aiAgents': `Agents IA`,
  'insights.menu.agentInventory': `Inventaire des agents`,
  'insights.menu.aiThreatDetection': `Détection des menaces`,
  'insights.menu.aiThreatPolicy': `Politique de menaces`,
  'insights.menu.insights': `Insights`,
  'insights.menu.detections': `Détections`,
  'insights.menu.recommendations': `Recommandations`,
  'insights.menu.exclusionRules': `Règles d'exclusion`,
  'insights.menu.reporting': `Rapports`,
  'insights.menu.integrationsConnections': `Intégrations et connexions`,
  'insights.menu.integrations': `Intégrations`,
  'insights.menu.connectors': `Connecteurs`,
  'pmc.explore': `Explorer`,
  'pmc.audit': `Audit`,
  'pmc.settings': `Paramètres`,
  'home': `Accueil`,
  'policies': `Politiques`,
  'computers': `Ordinateurs`,
  'computer-groups': `Groupes d'ordinateurs`,
  'jit-access-management': `Gestion d'accès JIT`,
  'analytics': `Analyses`,
  'auditing': `Audit`,
  'management-rules': `Règles de gestion`,
  'configuration': `Configuration`,
  'user-management': `Gestion des utilisateurs`,
  'status': `État`,
  'downloads': `Consoles et téléchargements`,
  'my_account': `Mon compte`,
  'sd': `Configuration`,
  'jump': `Asset Management`,
  'vault': `Coffre-fort`,
  'rep_console': `Paramètres de la console`,
  'users': `Utilisateurs et sécurité`,
  'reporting': `Rapports`,
  'public_site': `Portails publics`,
  'dashboard': `Dashboards`,
  'localization': `Localisation`,
  'management': `Gestion`,
  'appliance': `Appliance`,
  'login.status.index': `Informations`,
  'login.status_representatives.index': `Représentants`,
  'login.downloads.rep.index': `Rep Console`,
  'login.downloads.drivers.index': `Pilotes`,
  'login.my_account.profile.index': `Profil`,
  'login.my_account.security.index': `Sécurité`,
  'login.sd_general.index': `Options`,
  'login.issue.index': `Problèmes`,
  'login.team.index': `Équipes de support`,
  'login.skill.index': `Compétences`,
  'login.callback_button.index': `Boutons de support`,
  'login.custom_fields.index': `Champs personnalisés`,
  'login.ms_teams.index': `MS Teams`,
  'login.mcp_config.index': `Serveur MCP`,
  'login.pinned_clients.index': `Jump Clients`,
  'login.shared_jump_groups.index': `Asset Groups`,
  'login.jump_policies.index': `Asset Policies`,
  'login.jump_item_roles.index': `Asset Roles`,
  'login.push_agent.index': `Gateway`,
  'login.jump_item.index': `Assets`,
  'login.endpoint_automation.index': `Automatisation des endpoints`,
  'login.vault_account.index': `Comptes`,
  'login.vault_account_group.index': `Groupes de comptes`,
  'login.account_policy.index': `Politiques de comptes`,
  'login.vault_endpoint.index': `Endpoints`,
  'login.vault_domain.index': `Domaines`,
  'login.discovery.index': `Découverte`,
  'login.vault_options.index': `Options`,
  'login.vault_password_safe_connection.index': `Connexions`,
  'login.rep_profile.index': `Paramètres de Rep Console`,
  'login.custom_links.index': `Liens personnalisés`,
  'login.canned_message.index': `Messages prédéfinis`,
  'login.canned_script.index': `Scripts prédéfinis`,
  'login.special_action.index': `Actions spéciales`,
  'login.user.index': `Utilisateurs`,
  'login.rep_invite.index': `Invitation de représentant`,
  'login.security_providers.index': `Fournisseurs de sécurité`,
  'login.session_policy.index': `Politiques de session`,
  'login.group_policy.index': `Politiques de groupe`,
  'login.kerberos_keytab.index': `Kerberos Keytab`,
  'login.licensing.index': `Licences`,
  'login.session_report.index': `Support`,
  'login.license_reporting.index': `Licences`,
  'login.vault_reporting.index': `Coffre-fort`,
  'login.compliance.index': `Conformité`,
  'login.jump_item_reporting.index': `Asset`,
  'login.duplicate_pinned_clients_reporting.index': `Jump Clients en double`,
  'login.syslog_reporting.index': `Syslog`,
  'login.public_site.index': `Sites publics`,
  'login.business_hours.index': `Horaires`,
  'login.html_template.index': `Modèles HTML`,
  'login.customer_notice.index': `Avis clients`,
  'login.file_store.index': `Stockage de fichiers`,
  'login.ios_profile.index': `Configuration iOS`,
  'login.exit_survey.index': `Enquêtes de sortie`,
  'login.sd_client.index': `Client de support`,
  'login.dashboard.index': `Dashboards`,
  'login.dashboard.getNetworkRestrictions': `Restrictions réseau`,
  'login.nls.real_time_chat.index': `Chat en temps réel`,
  'login.settings.index': `Logiciel`,
  'login.security_settings.index': `Sécurité`,
  'login.site_settings.index': `Configuration du site`,
  'login.email_settings.index': `Configuration des e-mails`,
  'login.outbound_event.index': `Événements sortants`,
  'login.api_account.index': `Configuration API`,
  'login.support_settings.index': `Support`,
  'login.appliance.index': `Appliance`,
  'entitle.menu.requests': `Demandes`,
  'entitle.menu.identityGraph': `Autorisations`,
  'entitle.menu.workflows': `Flux d'approbation`,
  'entitle.menu.integrations': `Intégrations`,
  'entitle.menu.bundles': `Ensembles`,
  'entitle.menu.policies': `Politiques de droits innés`,
  'entitle.menu.tasks': `Tâches`,
  'entitle.menu.profile': `Mes paramètres`,
  'entitle.menu.accessReview': `Vue d'ensemble`,
  'entitle.menu.requestsLog': `Historique des demandes`,
  'entitle.menu.auditLogs': `Journaux d'audit`,
  'entitle.menu.settings': `Paramètres d'organisation`,
  'entitle.menu.users': `Utilisateurs`,
  'epml.menu.explore': `Explorer`,
  'epml.menu.audit': `Audit`,
  'epml.menu.settings': `Paramètres`,
  'epml.menu.policy': `Politique`,
  'epml.menu.endpoints': `Gestion des endpoints`,
  'epml.menu.installers': `Programmes d'installation`,
  'epml.menu.unifiedSearch': `Recherche unifiée`,
  'epml.menu.events': `Événements`,
  'epml.menu.consoleAudit': `Audit de la console`,
  'epml.menu.searchAndReplay': `Recherche et relecture`,
  'epml.menu.consoleAccess': `Accès à la console`,
  'epml.menu.epmlSettings': `Paramètres EPML`,
  'epml.menu.roles': `Rôles`,
  'epml.menu.siemConnections': `Connexions SIEM`,
  'epml.menu.directoryServices': `Services d'annuaire`,
  'epml.menu.linuxHostAuth': `Authentification de l'hôte Linux`,
  'menu-phantom-labs': `Phantom Labs`,
  'ai-coworkers.menu.dashboards': `Tableau de bord`,
  'ai-coworkers.menu.inventory': `Visibilité`,
  'ai-coworkers.menu.inventory.agents': `Agents IA`,
  'ai-coworkers.menu.inventory.mcp-servers': `Serveurs MCP`,
  'ai-coworkers.menu.inventory.model-endpoints': `Endpoints LLM`,
  'ai-coworkers.menu.inventory.agent-skills': `Compétences des agents`,
  'ai-coworkers.menu.inventory.endpoints': `Endpoints`,
  'ai-coworkers.menu.intelligence': `Renseignements`,
  'ai-coworkers.menu.agents.events': `Événements`,
  'ai-coworkers.menu.intelligence.coding-sessions': `Sessions IA`,
  'ai-coworkers.menu.control': `Protection`,
  'ai-coworkers.menu.control.policies': `Politiques`,
  'ai-coworkers.menu.control.exceptions': `Demandes d'exception`,
  'ai-coworkers.menu.control.yara-rules': `Règles YARA`,
  'ai-coworkers.menu.settings': `Paramètres`,
  'ai-coworkers.menu.settings.connectors': `Connecteurs`,
  'ai-coworkers.menu.settings.license': `Licence et utilisation`,
  'ai-coworkers.menu.settings.administration': `Administration`,
  'ai-coworkers.menu.agents.deployment': `Déploiement`,
  'ai-coworkers.menu.settings.update-strategy': `Stratégie de mise à jour`,
  'sa91c1893f06e9a91': `Jetons SCIM`,
  'sb5cd73af5ec790f6': `Identités de charge de travail`,
  's29c1fa87a0c0ee4c': `Authentification d'annuaire`,
  's177fa3e0b2ef5171': `Liste d'autorisation IP`,
  's4c9351ce0cc28196': `Navigation des produits`,
  's76902262e33e63b5': `Afficher ou masquer la navigation latérale`,
  's714ea1e6436002a2': `Garder la navigation épinglée`,
  's416434bef0c17abc': `Impossible de charger le menu. Fermez-le, puis rouvrez-le pour réessayer.`,
  'admin.menu.users': `Gestion des utilisateurs`,
  'admin.menu.identity-providers': `Fournisseurs d'identité et d'authentification`,
  'admin.menu.directory-auth': `Authentification d'annuaire`,
  'admin.menu.workload-identities': `Identités de charge de travail`,
  'admin.menu.scim-tokens': `Jetons SCIM`,
  'admin.menu.user-groups': `Groupes d'utilisateurs`,
  'admin.menu.roles': `Rôles`,
  'admin.menu.organization-settings': `Paramètres de l'organisation`,
  'admin.menu.ip-allowlist': `Liste d'autorisation IP`,
  'admin.menu.audit': `Journaux d'audit`,
  'admin.menu.site-admin': `Administration du site`,
  'admin.menu.site-admin.create': `Créer un site`,
  'siteSelectorLabel': `Site`,
  'siteSelectorSearchPlaceholder': `Rechercher des sites`,
  'siteSelectorNoSitesFound': `Aucun site trouvé`,
  'siteSelectorDataResidency': `résidence des données`,
  'breadcrumbNavLabel': `Fil d'Ariane`,
  'breadcrumbOverflowLabel': `Afficher plus d'éléments de navigation`,
};
